import axios from "axios";

const mpGeneratePixPayment = async ({
  value,
  description,
  payerEmail,
  payerCpf,
  payerName,
}) => {
  try {
    const { data } = await axios.post(`/mercadopago/payment/pix`, {
      value,
      description,
      payerEmail,
      payerCpf,
      payerName,
    });

    if (!data?.success) throw new Error();

    return {
      success: true,
      message: "Sucesso ao gerar pagamento",
      paymentId: data?.paymentId,
    };
  } catch (error) {
    return {
      success: false,
      message: "Erro ao gerar pagamento",
    };
  }
};

export { mpGeneratePixPayment };
